import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import ManagePage from '../../views/ManagePage/';
const GLOBAL = require('../../Globals');

class AssignTask extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			task : '',
			desc : '',
			priority : '',
			tdate : '',
			utype : '',
			cls : '',
			section : '',
			value : '',
			employee : '',
			depart : '',
			taskstatus : '',
			alertClass :'',
			_message : '',
			_redirect : false,
			posts: [],
			dept : [],
			stud : [],
			empl : []
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.onClick = this.onClick.bind(this);
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	onClick(e){
		
		document.getElementById("taskform").reset();
	}
	
	/** set value to react select **/
	handleChange(value){
		
		this.setState({value});
		console.log(this.state.value);
		
	}
	
	/** set value to react select **/
	handleInputChange(employee){
		
		this.setState({employee});
		console.log(this.state.employee);
		
	}
	
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.task && this.state.desc && this.state.priority && this.state.tdate && this.state.utype && this.state.taskstatus){
			$("#showLoader").show();
			PostData('task/addtask',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Task Assign Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("taskform").reset();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}

	componentDidMount() {
		
		this.getclass();
		this.getdepartment();
	}
	
	/** get Department **/
	getdepartment(){
		$("#showLoader").show();
		GetData('department/getdepartment').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					dept : responseJson
				});
			}
		});	  
	}
	
	/** get Class **/
	getclass(){
		
		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
  render() {
	  
	if(this.state._redirect){
		  
		return (<Redirect to={'/subject/subjectupdate/' + this.state.idd} />);

	}
	
	var items = this.state.posts;
	var dep = this.state.dept;
	
	/** set type select box **/
	this.type = [
		{value : '', name : 'Select'},
		{value : 'Student', name : 'Student'},
		{value : 'Employee', name : 'Employee'}
	];
	
	/** set status select box **/
	this.sta = [
		{value : '', name : 'Select'},
		{value : 'Open', name : 'Open'},
		{value : 'Onhold', name : 'Onhold'},
		{value : 'Resolved', name : 'Resolved'},
		{value : 'Closed', name : 'Closed'}
	];
	
	/** set Priority select box **/
	this.pri = [
		{value : '', name : 'Select'},
		{value : 'High Priority', name : 'High Priority'},
		{value : 'Normal Priority', name : 'Normal Priority'},
		{value : 'Low Priority', name : 'Low Priority'}
	];
	
	  /** map Student value to react multi select **/
	var val = this.state.stud.map(function(e,key) {
	   return (
		 {value : e.id, label : e.stdname}
	   );
	});
	
	 /** map Employee value to react multi select **/
	var eme = this.state.empl.map(function(e,key) {
	   return (
		 {value : e.id, label : e.empname}
	   );
	});
	
	/** get Employee By Department **/
	  if(this.state.depart){
		  $("#showLoader").show();
		GetData('employee/getempbydept/'+this.state.depart).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					empl : responseJson
				});
			}
		});
	  }		
	
	  /** get Section By Class **/
	$("#clas").change(function(){
		var fr = $(this).val();
		$("#showLoader").show();
		$.get(GLOBAL.BASE_URL+'section/getsectsbyclass/'+fr,function(o){
			$("#showLoader").hide();
			//$("#acHead").removeClass('chosen_a');
			$("#secs").html('');
			$('#secs')
				.append($("<option></option>")
				.attr("value",'')
				.text(' -Select Section- ')); 
			$.each(o,function(key,value){			
				   $('#secs')
					.append($("<option></option>")
					.attr("value",value.id)
					.text(value.secs)); 	
										
			});
			
		},'json');
	
	});
	
	/** get Student By Class & Section **/
	 if(this.state.cls && this.state.section){
		// $("#showLoader").show();
		GetData('student/getstudbyclsandsecfortask/'+this.state.cls+'/'+this.state.section).then((result) => {
			//$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					stud : responseJson
				});
			}
		}); 
	 }
	
	if(this.state.utype == 'Student'){
		
		$("#std").show(1000);
	}
	else{
		
		$("#std").hide(1000);
	}
	
	if(this.state.utype == 'Employee'){
		
		$("#emp").show(1000);
	}
	else{
		
		$("#emp").hide(1000);
	}
	
	if(this.state.ustype == 'Student'){
		
		$("#mcls").show(1000);
		$("#msec").show(1000);
		$("#mstd").show(1000);
	}
	else{
		
		$("#mcls").hide(1000);
		$("#msec").hide(1000);
		$("#mstd").hide(1000);
	}
	
	if(this.state.ustype == 'Employee'){
		
		$("#memp").show(1000);
		$("#mdep").show(1000);
	}
	else{
		
		$("#memp").hide(1000);
		$("#mdep").hide(1000);
	}
	
    return (
		<div>
		  <ManagePage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				<Row>
				  <Col md="12">
					<Card>
					  <form action="" method="post" role="form" id="taskform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<CardHeader>
							<strong>Assign Task</strong>
						</CardHeader>
						<CardBody>
							<Row>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Task <span className="text-danger">*</span></Label>
								  <Input type="text" name="task" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Description <span className="text-danger">*</span></Label>
								  <Input type="textarea" name="desc" onChange={this.onChange} required />
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Priority <span className="text-danger">*</span></Label>
								  <select name="priority" className="form-control" onChange={this.onChange} required>
									{this.pri.map((e, key) => {
										return <option key={key} value={e.value}>{e.name}</option>;
									})}	
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Task Date <span className="text-danger">*</span></Label>
								  <Input type="date" name="tdate" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">User Type <span className="text-danger">*</span></Label>
								  <select name="utype" className="form-control" onChange={this.onChange} required>
									{this.type.map((e, key) => {
										return <option key={key} value={e.value}>{e.name}</option>;
									})}	
								  </select>
								</FormGroup>
							  </Col>
							 </Row>
							  <Row id="std">
								<Col md="4">
								<FormGroup>
								  <Label htmlFor="name">Class <span className="text-danger">*</span></Label>
								  <select name="cls" onChange={this.onChange} className="form-control" id="clas"> 
									<option value="">Select Class</option>
									{
										items.map(function (item) {
											return <option value={item.id }>{item.class}</option>;
										})
									}
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="name">Section <span className="text-danger">*</span></Label>
								  <select name="section" onChange={this.onChange} className="form-control" id="secs">
									<option value="">Select Section</option>
									
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="name">Student <span className="text-danger">*</span></Label>
								  <Select value={this.state.value} onChange={this.handleChange} multi options={val} />
								</FormGroup>
							  </Col>
							  </Row>
							  <Row id="emp">
								<Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Department <span className="text-danger">*</span></Label>
								  <select name="depart" onChange={this.onChange} className="form-control" id="deprt"> 
									<option value="">Select Department</option>
									{
										dep.map(function (item) {
											return <option value={item.id }>{item.department}</option>;
										})
									}
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Employee <span className="text-danger">*</span></Label>
								  <Select value={this.state.employee} onChange={this.handleInputChange} multi options={eme}/>
								</FormGroup>
							  </Col>
							  </Row>
							 <Row>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Status <span className="text-danger">*</span></Label>
								  <select name="taskstatus" className="form-control" onChange={this.onChange} required>
									{this.sta.map((e, key) => {
										return <option key={key} value={e.value}>{e.name}</option>;
									})}	
								  </select>
								</FormGroup>
							  </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
							<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
						</CardFooter>
					  </form>
					</Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default AssignTask;


// WEBPACK FOOTER //
// ./src/task/AssignTask/AssignTask.js